import { Divider, Grid, Typography } from '@mui/material';

type DividerProps = { label: string };
export const SettingDivider = ({ label }: DividerProps) => {
  return (
    <Grid size={12}>
      <Divider sx={{ my: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
      </Divider>
    </Grid>
  );
};
